import { render, staticRenderFns } from "./SignPostIcon.vue?vue&type=template&id=3f7f2c2c&scoped=true&"
import script from "./SignPostIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignPostIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7f2c2c",
  null
  
)

export default component.exports